import {Component, Input, OnInit} from '@angular/core';
import {BlockComparator} from "../../../utils/text-compare";
import {V3Dictation, V3ExerciseSessionQuestionBase} from "../../../model/v3/cspa";

@Component({
    selector: 'app-dict-result',
    templateUrl: './dict-result.component.html',
    styleUrls: ['./dict-result.component.scss'],
    standalone: false
})
export class DictResultComponent implements OnInit {
  @Input() questions: V3ExerciseSessionQuestionBase<V3Dictation>[]

  constructor() { }

  ngOnInit(): void {
  }

  getCorrectAnswer(q: V3ExerciseSessionQuestionBase<V3Dictation>) {
    return q.questionDef.answerDef.answer
  }

  getStudentAnswer(q: V3ExerciseSessionQuestionBase<V3Dictation>) {
    const holder = q.questionDef.answerDef.answerHolder
    if (!holder?.answer) return [null]
    const correctAnswerStream = BlockComparator.tokenize(q.questionDef.answerDef.answer);
    const userAnswer = BlockComparator.tokenize(holder.answer || "");
    const result = BlockComparator.compare(correctAnswerStream, userAnswer);
    const blocks = BlockComparator.divideToBlocks(result, userAnswer);
    return BlockComparator.compressBlocks(blocks);
  }
}
